import * as React from 'react';

import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import { GridRowIdGetter, GridRowModel } from '@mui/x-data-grid-pro';
import { useTheme } from '@mui/material';

import { useTranslations } from '@fenetech/translations';
import { useDashboardPickupData } from './useDashboardPickupData';
import { generatePickupColumns } from "./PickupsGridColumns";
import useIsMobile from 'helpers/hooks/useIsMobile';
import { AddStatusColumnData } from 'components/Common/DataGridColumnGenerator';
import useUserInfo from "helpers/context/User/useUserInfo";
import CustomDataGridPro from "components/Common/CustomDataGridPro";

const PickupsGrid: React.FC<any> = (props: any) => {

    const tm = useTranslations();
    const theme = useTheme();
    const rawData = useDashboardPickupData();
    const isMobile = useIsMobile();
    const user = useUserInfo();

    const getRowId: GridRowIdGetter = (row: GridRowModel) => {
        return row.oKey;
    }

    const data = React.useMemo(() => {
        if (rawData) {
            return rawData.map((o) => AddStatusColumnData(o, "", theme, tm));
        } else {
            return null;
        }
    }, [rawData, theme, tm]);

    const columns = React.useMemo(() => {
        return generatePickupColumns(tm, data, theme, isMobile, user);
    }, [tm, data, theme, isMobile, user]);

    return <>
          <CustomDataGridPro
              rows={data}
              columns={columns}
              getRowId={getRowId}
              tableName="DashboardPickup"
              tableSubName={isMobile ? "Mobile" : ""}
              hideInMobileColumns={[
                "orderDate",
                "customerRef",
                "pickupDate",
                "mfgSiteName"
              ]}
          />
    </>;
};

export default PickupsGrid;
